<div class="col-md-12 pageTitle">
  <label class="pt-4 pl-4">Clinic Transaction Dashboard</label>
</div>
<div class="col-md-12 mb-3 mt-3">
  <div class="row">
    <div class="col-md-2">
      <ng-select [items]="clinicList" bindLabel="name" [clearable]="false" [addTag]="false" [multiple]="false"
        placeholder="Select Clinic" (change)="onClinicChange($event)" [(ngModel)]="clinic_selected">
      </ng-select>
    </div>
    <div class="col-md-2 text-left">
      <!-- <ng-container *ngIf="!doctor.subordinate_flag"> -->
      <ng-container>
        <ng-select [items]="doctorList" bindLabel="name" [clearable]="false" [addTag]="false" [multiple]="false"
          placeholder="Select Doctor" (change)="onChange($event)" [(ngModel)]="doctor_selected">
          <ng-template ng-option-tmp let-item="item">
            <div title="{{item.name}}">{{item.name}}</div>
          </ng-template>
        </ng-select>
      </ng-container>
    </div>
    <div class="col-md-2 offset-md-6">
      <my-date-range-picker name="mydaterange" class="float-right ml-4" [options]="myDateRangePickerOptions"
        [(ngModel)]="dateRange" required (dateRangeChanged)="changeDate($event)">
      </my-date-range-picker>
    </div>
  </div>
  <hr>

  <div class="col-md-12 row">
    <div class="col-md-7 ml-4 cardPieLayout">
      <app-linechart [lineChartData]="lineChartData" [lineChartLabels]="lineChartLabels"
        (valueChanged)="valueChanged($event)">
      </app-linechart>
    </div>
    <div class="col-md-4 ml-4 cardPieLayout">
      <app-piechart class="pielayout" [pieChartData]="pieChartData"></app-piechart>
    </div>
  </div>
  <div class="col-md-12">
    <div class="cardLayout">
      <div>
        <h5 class="text-left cardTitle">Pets Cared</h5>
        <h2 class="text-left cardValue" style="color: #307BFF;">{{transactionDetails?.petCaredCount || 0}}</h2>
      </div>
    </div>
    <div class="cardLayout">
      <div>
        <h5 class="text-left cardTitle">Phone Call</h5>
        <h2 class="text-left cardValue" style="color: #F05837;">{{transactionDetails?.phoneConsultationCount || 0}}</h2>
      </div>
    </div>
    <div class="cardLayout">
      <div class="">
        <h5 class="text-left cardTitle">Paid Token</h5>
        <h2 class="text-left cardValue" style="color: #F0AD4D;">{{transactionDetails?.paidToken || 0}}</h2>
      </div>
    </div>
    <div class="cardLayout">
      <div class="">
        <h5 class="text-left cardTitle">Paid in Clinic</h5>
        <h2 class="text-left cardValue" style="color: #6485AD;">&#8377; {{transactionDetails?.earnedByClinic || 0}}</h2>
      </div>
    </div>
    <div class="cardLayout">
      <div class="">
        <h5 class="text-left cardTitle">Earned From Phone Call</h5>
        <h2 class="text-left cardValue" style="color: #A2CC61;">&#8377; {{transactionDetails?.earnedByPhone || 0}}</h2>
      </div>
    </div>
    <div class="cardLayout">
      <div class="">
        <h5 class="text-left cardTitle">Earned From Paid Token</h5>
        <h2 class="text-left cardValue" style="color: #F8BB70;">&#8377; {{transactionDetails?.earnedByToken || 0}}</h2>
      </div>
    </div>
    <div class="cardLayout">
      <div class="">
        <h5 class="text-left cardTitle">Paid Amount</h5>
        <h2 class="text-left cardValue" style="color: #F26C4F;">&#8377; {{transactionDetails?.totalAmountPaid || 0}}
        </h2>
      </div>
    </div>
    <div class="cardLayout">
      <div class="">
        <h5 class="text-left cardTitle">Pending Amount</h5>
        <h2 class="text-left cardValue" style="color: #D96973;">&#8377; {{transactionDetails?.totalBalance || 0}}</h2>
      </div>
    </div>
    <div class="cardLayout">
      <div class="">
        <h5 class="text-left cardTitle">Total Earning</h5>
        <h2 class="text-left cardValue" style="color: #5BC35C;">&#8377; {{transactionDetails?.totalEarning || 0}}</h2>
      </div>
    </div>
    <div class="cardLayout d-none">
      <div class="">
        <h5 class="text-left cardTitle">Impatient</h5>
        <h2 class="text-left cardValue" style="color: #378C96;"></h2>
      </div>
    </div>
  </div>
</div>
